import React from 'react'
import { Helmet } from 'react-helmet'
import '../../Custom.css'
import banner from '../../images/banners/us.jpg'
export default function Send_parcels_US() {
  return (
    <div className="improvelive">
      <Helmet>
        <title>Shypv | Send Parcel to USA</title>
      </Helmet>
      <section className="your_business_page fw" style={{ backgroundImage: `url(${banner})`, backgroundAttachment: 'fixed', backgroundSize: 'cover' }}>
        <div className="container"><div className="row">
          <div className="col-md-12 col-sm-12 your_business text-center">
            <div className="business_content">
              <h1 className="mainhead">Send Parcel to USA</h1>
              <p>For A Fraction Of The Cost</p>

            </div>
          </div>
        </div>
        </div>
      </section>
      <div className="pages_content improvelive">
        <div className="container">
          <div className="row">
            <div id="primary" className="content-area" style={{ float: 'left', width: '100%' }}>
              <main id="main" className="site-main" role="main">
                <div className="single_content">
                  <article id="post-272" className="post-272 track type-track status-publish has-post-thumbnail hentry"><div className="become_driver post_driver"><div className="entry-content">
                    <p>Shypv is here to simplify the parcel shipping process between the USA and the UAE, giving consumers and SMEs alike the freedom to send more parcels for less, fast. </p>

                    <a href="/" target="_blank" style={{ display: 'block', width: '20%', marginTop: '3%' }}> <button class="smartbtn2" style={{ background: '#3c50e0', color: '#fff' }}>Get A Quote</button></a>

                    <h5 style={{ marginTop: '2%' }}>Low-Cost Parcels, High-Quality Results</h5>
                    <p>At Shypv, we’re on a mission to make accessing international shipments from USA to  the Middle East and GCC and vice versa faster and easier than ever. Our innovative parcel delivery service leverages the power of today's top global couriers, streamlined digital features, and budget-friendly pricing options to give more shoppers and business owners the power to easily send and receive parcels from their favorite brands and retailers. From New York to Dubai and every stop and between, we make shipping to and to and from the UAE as easy as one click</p>

                    <h5 style={{ marginTop: '2%' }}>Why Ship With Shypv:</h5>
                    <p><b>Fast</b></p>
                    <p>Featuring fast delivery transit times from and to the USA and back, our couriers save you the time and stress of waiting around for an important package. </p>
                    <p><b>Affordable</b></p>
                    <p>We offer exclusive savings to small and medium-sized business owners, as well as our elite Wallet Account users, creating cost-effective solutions for all your USA-to-UAE shipping needs</p>

                    <p><b>Convenient</b></p>
                    <p>No post office? No problem. Our intuitive platform allows you to ship and track your parcels all in one place, so you can access your shipments anytime. </p>

                    <p><b>Reliable</b></p>
                    <p>We’re proud to partner with today’s leading global couriers, including FedEx, DHL, UPS, and Aramex, allowing us to deliver more parcels for less with exclusive wholesale pricing. </p>

                    <h5>We Bring More Buyers & Businesses Together:</h5>
                    <p><b>90,000+ Users</b></p>
                    <p>Our platform has served more than 90,000 users in the USA and UAE, making Shypv one of the world’s fastest-growing parcel delivery services for sending a parcel abroad.  </p>

                    <p><b> 40%+ Savings</b></p>
                    <p>We make accessing low-cost parcels fast and easy, including up to 40% off for our preferred business partners and exclusive discounts for Wallet Account users. </p>


                    <p><b> Endless Routes</b></p>
                    <p>Whether you’re shipping from Los Angeles to Dubai, Chicago to Dubai, Abu Dhabi to New York, or anywhere else in between, our expansive UAE to USA shipping network is a rapid parcel delivery solution for you. </p>


                    <h5 style={{ marginTop: '2%' }}>How To Send A Parcel To USA (And Back) In 5 Steps:</h5>
                    <p><b> 1.	Get A Quote</b></p>
                    <p>We make finding the most affordable rate for your parcel shipments fast and easy with instant access to quotes from today’s top couriers. Just tell us how many parcels you’re sending and where they’re going, and we’ll match you with the best option for your budget. </p>

                    <p><b>2.	Choose A Courier </b></p>


                    <p> Our elite roster of couriers includes industry leaders like FedEx, DHL, UPS, and Aramex, allowing us to ship express parcels from and to the United Arab Emirates at a fraction of the cost. </p>
                    <p></p>

                    <p><b>3.	Drop-Off The Parcel </b></p>
                    <p>Say Goodbye to waiting in line at the Post Office and Hello to modern convenience. Our platforms give you the option to have parcels collected directly from your doorstep, and we’ll let you know as soon as we’re on our way to pick them up. </p>

                    <p><b>4.	Track Your Shipment </b></p>
                    <p>Easily track your courier to and from Dubai and Abu Dhabi with no third-party apps required. Our platform uses in-house tracking tools to provide you with real-time updates on the status of your delivery, so you never have to wonder where in the world your parcel went. </p>

                    <p><b> 5.	Complete Your Delivery</b></p>
                    <p>Whether you’re sending a small parcel or a large batch of items, Shypv offers the cheapest door-to-door deliveries for shipments from the UAE to the USA, completing your most important deliveries in record time</p>

                    <h5 style={{ marginTop: '2%' }}>Ready To Send More And Spend Less?</h5>
                    <h6><b>Create A Wallet Account Today</b></h6>

                    <p>With a Shypv exclusive Wallet Account, you can simplify the shipping process even further with automated payment options and 10% savings on shipments from our top couriers.</p>

                    <a href="/register" target="_blank" style={{ display: 'block', width: '20%', marginTop: '3%' }}> <button class="smartbtn2" style={{ background: '#3c50e0', color: '#fff' }}>Create An Account</button></a>
                  </div>
                  </div>
                    <footer className="entry-footer " /></article>
                  <div className /></div>
              </main>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
